import request from '@/utils/request'

export const type = (data) => {
  return request({
    url: '/fn/venue/type',
    method: 'post',
    data,
  })
}

export const calendar = (data) => {
  return request({
    url: '/fn/venue/calendar',
    method: 'post',
    data,
  })
}

export const surplusNum = (data) => {
  return request({
    url: '/fn/venue/surplusNum',
    method: 'post',
    data,
  })
}

export const list = (data) => {
  return request({
    url: '/fn/venue/list',
    method: 'post',
    data,
  })
}

export const occupyTime = (data) => {
  return request({
    url: '/fn/venue/occupyTime',
    method: 'post',
    data,
  })
}

export const reserve = (data) => {
  return request({
    url: '/fn/venue/reserve',
    method: 'post',
    data,
  })
}

export const reserveList = (data) => {
  return request({
    url: '/fn/venue/reserve/list',
    method: 'post',
    data,
  })
}

export const detail = (data) => {
  return request({
    url: '/fn/venue/reserve/detail',
    method: 'post',
    data,
  })
}

export const cancel = (data) => {
  return request({
    url: '/fn/venue/cancel',
    method: 'post',
    data,
  })
}
